import { render, staticRenderFns } from "./especialidades.vue?vue&type=template&id=0c0a30b4&scoped=true"
import script from "./especialidades.vue?vue&type=script&lang=js"
export * from "./especialidades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0a30b4",
  null
  
)

export default component.exports